export default {"src":"/_next/static/media/logo.95b665ee.svg","height":272,"width":1152,"blurWidth":0,"blurHeight":0};